module.exports = __webpack_public_path__ + "static/media/clientes-logo-05.2ade1dee.png";